module.exports = __webpack_public_path__ + "img/videoDefult.fe79cc06.png";